export { default } from './EventRegistration';
